import { avatarHue, initials } from '@astrologermatch/shared';

// Ported from prototype Home.jsx / PublicProfile.jsx (Stars, Avatar).

export function Stars({ value, size = '' }: { value: number; size?: string }) {
  const full = Math.max(0, Math.min(5, Math.round(value)));
  return (
    <span className={`stars ${size}`.trim()} role="img" aria-label={`${String(value)} out of 5`}>
      {'★★★★★'.slice(0, full)}
      <span className="stars-off">{'★★★★★'.slice(full)}</span>
    </span>
  );
}

export function Avatar({
  name,
  photoUrl,
  big = false,
}: {
  name: string;
  photoUrl?: string | null;
  big?: boolean;
}) {
  const cls = `avatar${big ? ' avatar-xl' : ''}`;
  if (photoUrl) {
    return (
      <div className={cls}>
        <img src={photoUrl} alt={name} className="avatar-img" loading="lazy" />
      </div>
    );
  }
  const hue = avatarHue(name);
  return (
    <div
      className={cls}
      aria-hidden="true"
      style={{
        background: `linear-gradient(135deg, hsl(${String(hue)} 55% 42%), hsl(${String((hue + 50) % 360)} 60% 30%))`,
      }}
    >
      {initials(name)}
    </div>
  );
}

export function Spinner({ label }: { label?: string }) {
  return (
    <span className="small muted" role="status">
      <span className="dots" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>{' '}
      {label ?? 'Loading…'}
    </span>
  );
}
